const getSocialAppId = window.settings.notifications && window.settings.notifications.getSocialAppId;

//Start GetSocial SDK
export const loadGetSocialJS = () => {
    const existingScript = document.getElementById('GetSocial');
    if (!existingScript) {
        return new Promise (function(resolve, reject){
            if(getSocialAppId) {
                var script = document.createElement('script');
                script.type= 'text/javascript';
                script.async = true;
                script.id = 'GetSocial';
                if((navigator.userAgent.indexOf("MSIE") != -1 ) || (!!document.documentMode == true ))
                {
                    script.src = 'https://websdk.getsocial.im/sdk.legacy.min.js';
                } else {  
                    script.src = 'https://websdk.getsocial.im/sdk.min.js';
                }
                script.onload = resolve;
                script.onerror =  () => {
                    reject('Cannot load GetSocial js')
                    document.head.removeChild(script);
                }
                document.head.appendChild(script);
            } else {
                resolve(null);
            }   
        })
    } else {
        return new Promise (function(resolve){
            resolve();
        })
    }
}

// Starting Intialising GetSocial SDK
export const initGetSocialSDK = async (getSocialAppId) => {
    if(getSocialAppId) {
        return await loadGetSocialJS()
        .then(()=> {
            return new window.GetSocialSDK({appId: getSocialAppId});
        })
        .catch(function (error) {
            console.error('Unable to initialise GetSocial SDK: ' + error);
        });  
    }
}
//End Intialising GetSocial SDK 